import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as mainActions,
} from '../../../../redux/modules/main';

import ChampionshipAdminsSectionView from './ChampionshipAdminsSectionView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './ChampionshipAdminsSectionView';

const mapStateToProps = ({
  auth,
}: $State): $StateProps => ({
  auth,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(ChampionshipAdminsSectionView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
